import { request } from "#/utils/request";

interface IAgenciaConta {
  documento: string;
}

export interface IAgenciaContaComissionado {
  data: AgenciaContaComissionadoData;
  errors: string | null;
}

export interface AgenciaContaComissionadoData {
  contas: Conta[];
}

export interface Conta {
  agencia: string;
  conta: string;
  codigoComissionado: string;
  nome: string;
  posto: string;
  documentoTitular: string;
}

/** Endpoints */
export const getAgenciaContaComissionado = async ({
  documento,
}: IAgenciaConta) =>
  (
    await request.get<IAgenciaContaComissionado>(
      `/associados/agencia-contas?documento=${documento}`,
      {}
    )
  ).data;
